<template>
    <div class="app-container" style="padding-bottom:50px;background: #f4f5f7;">
      <BjSteps active="3" :title="$t('billingPage.DEPDeposit')" :defaultOptions="[$t('billingPage.DEPsub'),$t('billingPage.DEPAppro'),$t('billingPage.DEPTop')]">
        <template slot="right">
          <!-- 返回 -->
          <el-button @click="handleClose">{{ $t('backText') }}</el-button>
          <!-- 保存 -->
          <el-button v-if="$route.query.type == 'add'" type="primary" @click="handleConfirm">{{ $t('submitText') }}</el-button>
          <!-- 已收货 -->
          <el-button v-if="$route.query.type == 'view'&&!$store.getters.cusId" :disabled="form.status != 'Pending'" type="primary" @click="handleFormOpen('Received')">{{ $t('ReceivedText1') }}</el-button>
          <!-- 已拒绝 -->
          <el-button v-if="$route.query.type == 'view'&&!$store.getters.cusId" :disabled="form.status != 'Pending'" type="primary" @click="handleFormOpen('Declined')">{{ $t('DeclinedText1') }}</el-button>
        </template>
      </BjSteps>
      
      <el-form ref="form" :model="form" label-position="top" :rules="rules" label-width="160px">
        <div class="flex flex-spacebetween profit-top">
          <BjDivider>{{ $t('billingPage.DEPInfo') }}</BjDivider>
          <div class="profit-topLeft">
            <el-row :gutter="20" style="margin-top: 10px;">
              <!-- From -- Admin端-->
              <el-col :span="colSpan" v-if="!$store.getters.cusId">
                <el-form-item :label="$t('billingPage.DEPFrom')" prop="clientCode">
                  <BjSelectLov v-model="form.clientCode" :disabled="$route.query.type == 'view'" :option-list="clientCodeList" :placeholder="$t('billingPage.DEPFrom')" />
                </el-form-item>
              </el-col>
              <!-- From -- User端-->
              <el-col :span="colSpan" v-if="$store.getters.cusId">
                <el-form-item :label="$t('billingPage.DEPFrom')" prop="clientCode">
                  <BjInput v-model="form.clientCode" disabled/>
                </el-form-item>
              </el-col>
              <!-- Account Details -->
              <el-col :span="colSpan" v-if="$store.getters.cusId">
                <el-form-item :label="$t('billingPage.DEPDetail')" prop="addressFrom">
                  <BjInput v-model="addressFrom" :disabled="$route.query.type == 'view'" @input="inputFrom"/>
                </el-form-item>
              </el-col>
              <!-- To -->
              <el-col :span="colSpan*2">
                <el-form-item :label="$t('billingPage.DEPTo')" prop="addressTo">
                  <BjInput disabled v-model="addressTo" placeholder="Cargo Solutions Group Pty Ltd, 063121, 11418410"/>
                </el-form-item>
              </el-col>
              <!-- Amount -->
              <el-col :span="colSpan">
                <el-form-item :label="$t('billingPage.DEPAmount')" prop="amount">
                  <BjInputMoney v-model="form.amount" :disabled="$route.query.type == 'view'" :placeholder="$t('billingPage.DEPAmount')" clearable ><template slot="append">AUD</template></BjInputMoney>
                </el-form-item>
              </el-col>
              <!-- Transaction Time -->
              <el-col :span="colSpan">
                <el-form-item :label="$t('billingPage.DEPTime')" prop="transferTime">
                  <el-date-picker
                    v-model="form.transferTime"
                    class="full-width"
                    format="dd/MM/yyyy mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    :placeholder="$t('chooseText')"
                    :disabled="$route.query.type == 'view'"
                  />
                </el-form-item>
              </el-col>
              <!-- Description -->
              <el-col :span="colSpan*2">
                <el-form-item :label="$t('billingPage.DEPDes')" prop="description">
                  <BjInput v-model="form.description" :disabled="$route.query.type == 'view'" :maxlength="MAX_LENGTH.PRIORITY" type="textarea" :rows="5" show-word-limit autosize />
                </el-form-item>
              </el-col>
              <!-- file upload -->
              <el-col :span="colSpan*2">
                <div class="flex flex-spacebetween" style="margin-top:10px;">
                  <div class="profit-fileLeft">
                    <el-form-item :label="$t('billingPage.DEPScre')" prop="fileList"> 
                      <UploadFile ref="UploadFileRef" class="avatar-uploader" :limit="1" :limit-size="5 * 1024" accept="image/png,image/jpeg," :accept-list="['image/jpeg', 'image/png']" auto-upload limit-hide @handleFileListChange="fileChange">
                        <template slot="default">
                          <el-button :disabled="form.screenshotUrl || $route.query.type == 'view'" size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
                        </template>
                      </UploadFile>
                    </el-form-item>
                  </div>
                  <div class="profit-fileRight">
                    <template v-if="form.screenshotUrl">
                      <div class="file" style="line-height:1.5;font-weight: 500;font-size: 14px;">
                        <div class="fileUpload">
                          <div class="flex-align flex-spacebetween" style="color: #3173d0; cursor: pointer;">
                            <div class="flex">
                              <div style="width: 120px;" class="ellipsis">
                                <span class="mr20">screenshot.png</span>
                              </div>
                            </div>
                            <div class="flex-align flex-spacebetween">
                              <el-button size="mini" class="edit-btn" style="font-size: 12px;margin-right:10px" @click="downloadImageUrl(form.screenshotUrl, 'screenshot.png')">{{ $t('downloadText') }}<i class="el-icon-download el-icon--right"></i></el-button>
                              <el-button :disabled="$route.query.type == 'view'" size="mini" class="delete-btn" style="font-size: 12px;margin-right:10px" @click="delImg()">{{ $t('delText') }}<i class="el-icon-delete red el-icon--right"></i></el-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template> 
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="profit-topRight">
            <BjDivider>{{$t('billingPage.DEPID')}}: {{ form.paymentId }}</BjDivider>
            <!-- 截图 展示 -->
            <div style="width: 100%; height: 370px;border: 1px;" v-if="form.screenshotUrl">
              <img :src="form.screenshotUrl" style="width: 100%; height: 100%;object-fit: contain;"/>
            </div>
          </div>
        </div>
      </el-form>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="form2.title"
        :visible.sync="addDialogVisible"
        width="500px"
        :before-close="handleFormClose"
      >
        <el-form ref="form2" :model="form2" :rules="rules2" label-width="100px">
          <el-form-item :label="$t('billingPage.DEPRemark')" prop="remark">
            <BjInput v-model="form2.remark" :maxlength="MAX_LENGTH.PRIORITY" type="textarea" :rows="5" show-word-limit autosize />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleFormClose('form2')">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="submitForm('form2')">{{ $t('okText') }}</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  <script>
  import { billApi  } from '@/api';
  import viewMiXin from '@/utils/view-mixin.js';
  import UploadFile from '@/views/center-business/third/csg/order/components/UploadFile';
  // import orderLog from '@/utils/log.js';
  
  export default {
    name: 'BusinessBillingDeposiInfo',
    components: { UploadFile },
    mixins: [viewMiXin],
    data() {
      return {
        colSpan: 12,
        clientCodeList:[],
        addressFrom:null,
        addressTo:null,
        form: {
          amount:null,
          transferTime:null,
          fromDetail:{
            type: "raw",
            rawInfo:null,
          },
          screenshotUrl:null,
          clientCode: this.$store.getters.userInfo.clientCode || null,
        },
        addDialogVisible: false,
        form2: {
          id:null,
          status:null,
          remark:null,
          title:null,
        },
        // 文件上传
        fileList:[],
        rules2: {
          remark: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        },
      };
    },
    computed:{
      rules() {
        const validateFrom = (rule, value, callback) => {
          this.$nextTick(() => {
            if(this.$store.getters.cusId&&!this.form.fromDetail.rawInfo){
              callback(new Error(this.$t('inputText')));
            }
            callback();
          });
        };
        const validateAuditTime = (rule, value, callback) => {
          this.$nextTick(() => {
            if (!this.form.transferTime) {
              callback(new Error(this.$t('chooseText')));
            }
            callback();
          });
        };
        return {
          clientCode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
          addressFrom: [{ required: true, validator: validateFrom, trigger: 'blur' }],
          amount: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          transferTime: [{ required: true, validator: validateAuditTime, trigger: 'change' }],
        };
      },
    },
    created(){  
      console.log(this.$store,'store')
      this.getClientInfoList();
      if(this.$route.query.type != 'add'){
        this.getFormData();
      }
    },
    methods: {
      // 获取所有客户信息列表
      getClientInfoList() {
        billApi.getClientInfoList().then(res => {
          console.log(res,'res');
          res.data.forEach(item => {
            item.label = `${item.label} - ${item.value}`;
          });
          this.clientCodeList = res.data;
        });
      },
      // 根据id获取详情页数据
      getFormData() {
        billApi.getDepositDetail({ id: this.$route.query.id }).then(async res => {
            this.form = res.data;
            this.addressFrom = this.form.fromDetail.rawInfo||null
            this.addressTo = this.form.toDetail.accountName+', '+this.form.toDetail.bsb+', '+this.form.toDetail.accountNumber
          });
      },
      // 传参用
      inputFrom(n,m){
        this.form.fromDetail.rawInfo = n
      },
      // 删除图片
      delImg(){
        this.form.screenshotUrl = null
      },
      // 单个上传的文件
      fileChange(file) {
        this.form.screenshotUrl = this.normalizeDownloadUrl(file[0]?.url);
      },
      /* 保存 */
      handleConfirm() {
        this.$refs.form.validate(valid => {
          if (valid) {
            billApi.toDeposit(this.form).then(res=>{
              if (res.code=='200' || res.success === true) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.complete('BusinessBillingDeposit');
                }, 500);
              }
            })
          }
        });
      },
      handleFormOpen(state) {
        this.form2.title = state == 'Received' ? this.$t('ReceivedText1') : this.$t('DeclinedText1');
        this.form2.id = this.form.id;
        this.form2.remark = this.form.remark;
        this.form2.status = state;
        this.addDialogVisible = true;
      },
      handleFormClose(formName) {
        this.addDialogVisible = false;
        this.$refs[formName].resetFields();
      },
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (!valid) return this.$scrollToFormError();
          const POST_DATA = {
            id: this.form2.id,
            status: this.form2.status,
            remark: this.form2.remark,
          }
          billApi.approveDeposit(POST_DATA).then(res=>{
            if (res.code=='200' || res.success === true)  {
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.addDialogVisible = false;
              this.$refs[formName].resetFields();
              setTimeout(() => {
                this.complete('BusinessBillingDeposit');
              }, 500);
            }
          })
        });
      },
      /* 返回 */
      handleClose() {
        this.cancel();
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .app-container {
    width: 100%;
  }
  .profit{
      &-title{
          padding: 0 20px;
          border: 1px solid #ddd;
          border-radius: 10px;
          background: #fff;
          margin-bottom: 20px;
      }
      &-top{
          padding: 0 20px 50px;
          border: 1px solid #ddd;
          border-radius: 10px;
          background: #fff;
          margin-bottom: 20px;
          min-height: 480px;
      }
      &-bottom{
          padding: 0 20px 50px;
          border: 1px solid #ddd;
          border-radius: 10px;
          background: #fff;
          margin-bottom: 20px;
      }
      &-topLeft{
          background: #fff;
          width: 50%;
          padding: 0 20px;
      }
      &-topRight{
          background: #fff;
          width: 50%;
          padding: 0 20px;
      }
      &-fileLeft{
          background: #fff;
          width: 120px;
          padding: 0 20px;
      }
      &-fileRight{
          background: #fff;
          width: calc(100% - 120px);
          padding: 0 20px;
      }
      &-left{
          background: #fff;
          width: 50%;
          padding: 0 20px;
          border: 1px solid #ddd;
          border-radius: 10px;
      }
      &-right{
          background: #fff;
          width: 49%;
          padding: 0 20px;
          border: 1px solid #ddd;
          border-radius: 10px;
      }
      
  }
  </style>
  
